import { z } from 'zod';
import { cursorPageSchema, cursorQuerySchema } from './pagination.js';
/**
 * Контракт журнала действий.
 *
 * Журнал нужен не для красоты. В системе, где агент пишет живым людям и
 * отправляет конверсии в трекер, вопрос «кто поменял ключ и когда» возникает
 * в первый же неприятный день. Поэтому запись в журнал только дописывается,
 * а читается — отдельным эндпоинтом с фильтрами и курсором.
 *
 * Поля before и after намеренно типизированы как unknown: там лежит уже
 * обезличенный снимок сущности (секреты в него не попадают — за это отвечает
 * слой маскирования), и его форма зависит от вида сущности.
 */
export const auditEntrySchema = z.object({
    id: z.uuid(),
    at: z.iso.datetime(),
    action: z.string(),
    entityType: z.string(),
    entityId: z.string().nullable(),
    actorUserId: z.uuid().nullable(),
    /** Адрес автора записи. Подставляется сервером, из запроса не принимается. */
    actorEmail: z.string().nullable(),
    ip: z.string().nullable(),
    before: z.unknown().nullable(),
    after: z.unknown().nullable(),
});
export const auditQuerySchema = cursorQuerySchema.extend({
    /** Фильтр по виду сущности: credential, membership, workspace, job. */
    entityType: z.string().max(100).optional(),
    /** Фильтр по действию: credential.upsert, member.remove и так далее. */
    action: z.string().max(100).optional(),
    actorUserId: z.uuid().optional(),
    /** Границы периода включительно. */
    from: z.iso.datetime().optional(),
    to: z.iso.datetime().optional(),
});
export const auditPageSchema = cursorPageSchema(auditEntrySchema);
//# sourceMappingURL=audit.js.map